import cx from 'classnames';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type RegistrationConditionMessageProps = {
  className?: string;
};

/** Generic message shown when the user doesn't validate the session registration condition. */
const RegistrationConditionMessage: FC<RegistrationConditionMessageProps> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <p
      className={cx(
        'registration-unavailable',
        'registration-unavailable--closed-registration-condition',
        className,
      )}
    >
      {t('workshops.messages.closed-registration-condition')}
    </p>
  );
};

RegistrationConditionMessage.defaultProps = {
  className: undefined,
};

export default RegistrationConditionMessage;
